export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/src/number.js
// module id = ./node_modules/d3-scale/src/number.js
// module chunks = vendor